module.exports = __webpack_public_path__ + "img/cultura_banner.9d46b1df.png";